import { render, staticRenderFns } from "./AppReport.vue?vue&type=template&id=065bdf6c&scoped=true&"
import script from "./AppReport.vue?vue&type=script&lang=js&"
export * from "./AppReport.vue?vue&type=script&lang=js&"
import style0 from "./AppReport.vue?vue&type=style&index=0&id=065bdf6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065bdf6c",
  null
  
)

export default component.exports